(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-bundle-two"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-bundle]').forEach(function (root) {
      if (root.dataset.mfBundleReady) return;
      root.dataset.mfBundleReady = '1';

      var data = root.querySelector('[data-mf-bundle-variants]');
      if (!data) return;

      var variants = [];
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      var colorPos = parseInt(root.dataset.colorPos, 10) || 1;
      var rows = root.querySelectorAll('[data-mf-bundle-row]');
      var button = root.querySelector('[data-mf-bundle-add]');
      var label = root.querySelector('[data-mf-bundle-label]');
      var error = root.querySelector('[data-mf-bundle-error]');

      function find(row) {
        var colorEl = row.querySelector('[data-mf-bundle-color]');
        var sizeEl = row.querySelector('[data-mf-bundle-size]');
        var colorVal = colorEl ? colorEl.value : null;
        var sizeVal = sizeEl ? sizeEl.value : null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var first = colorPos === 1 ? v.o1 : v.o2;
          var second = colorPos === 1 ? v.o2 : v.o1;
          var colorOk = colorVal === null || first === colorVal;
          var sizeOk = sizeVal === null || second === sizeVal;
          if (colorOk && sizeOk) return v;
        }
        return null;
      }

      function paint(row) {
        var v = find(row);
        var thumb = row.querySelector('[data-mf-bundle-thumb]');
        if (thumb && v && v.img) thumb.src = v.img;
      }

      rows.forEach(function (row) {
        paint(row);
        row.querySelectorAll('select').forEach(function (sel) {
          sel.addEventListener('change', function () { paint(row); });
        });
      });

      var ends = root.dataset.ends;
      var expired = false;
      if (ends) {
        var when = Date.parse(ends);
        if (!isNaN(when) && Date.now() > when) expired = true;
      }

      if (expired) {
        root.hidden = true;
        return;
      }

      var anchor = document.querySelector('.product-info [data-buy-buttons]');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(root, anchor);
        if (root.dataset.hideAtc === 'true') {
          anchor.style.display = 'none';
          var sticky = document.querySelector('[data-sticky-bar]');
          if (sticky && root.dataset.hideSticky === 'true') sticky.style.display = 'none';
        }
      }

      button.addEventListener('click', function () {
        error.hidden = true;
        var items = [];
        var missing = false;

        rows.forEach(function (row) {
          var v = find(row);
          if (!v) { missing = true; return; }
          items.push({ id: v.id, quantity: 1 });
        });

        if (missing || items.length !== rows.length) {
          error.textContent = 'That combination is not available. Please pick another colour or size.';
          error.hidden = false;
          return;
        }

        var original = label.textContent;
        button.disabled = true;
        label.textContent = 'Adding';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () {
            button.disabled = false;
            label.textContent = original;
            error.textContent = 'Something went wrong adding these to your cart. Please try again.';
            error.hidden = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-maattabel"]) return;
  try {
    
  (function () {
    var SIZE_WOORDEN = ['size', 'maat'];

    function zoekMaatkop(info) {
      var koppen = info.querySelectorAll('.product-info__option-header');
      for (var i = 0; i < koppen.length; i++) {
        var label = (koppen[i].textContent || '').trim().toLowerCase();
        for (var j = 0; j < SIZE_WOORDEN.length; j++) {
          if (label.indexOf(SIZE_WOORDEN[j]) !== -1) return koppen[i];
        }
      }
      return null;
    }

    function zet() {
      var houder = document.querySelector('[data-mf-maattabel]');
      if (!houder) return true;
      var knop = houder.querySelector('[data-mf-maattabel-knop]');
      var venster = houder.querySelector('[data-mf-maattabel-venster]');
      if (!knop || !venster) return true;

      var info = document.querySelector('.product-info');
      var kop = info ? zoekMaatkop(info) : null;
      if (!kop) return false;

      if (knop.dataset.mfGeplaatst !== 'true') {
        kop.appendChild(knop);
        kop.classList.add('mf-maattabel-kop');
        knop.dataset.mfGeplaatst = 'true';
      }

      if (!knop.dataset.mfGekoppeld) {
        knop.dataset.mfGekoppeld = 'true';
        knop.addEventListener('click', function () {
          if (typeof venster.showModal === 'function') {
            venster.showModal();
          } else {
            venster.setAttribute('open', 'open');
          }
        });
        var sluit = houder.querySelector('[data-mf-maattabel-sluit]');
        if (sluit) {
          sluit.addEventListener('click', function () {
            if (typeof venster.close === 'function') {
              venster.close();
            } else {
              venster.removeAttribute('open');
            }
          });
        }
        venster.addEventListener('click', function (e) {
          if (e.target === venster && typeof venster.close === 'function') {
            venster.close();
          }
        });
      }
      return true;
    }

    var pogingen = 0;
    function probeer() {
      if (zet()) return;
      pogingen += 1;
      if (pogingen < 40) setTimeout(probeer, 250);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', probeer);
    } else {
      probeer();
    }
    document.addEventListener('shopify:section:load', probeer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-size-chart-inline"]) return;
  try {
    
  (function () {
    var SIZE_WORDS = ['size', 'maat'];
    var tries = 0;

    function findSizeHeader(info) {
      var headers = info.querySelectorAll('.product-info__option-header');
      for (var i = 0; i < headers.length; i++) {
        var label = (headers[i].textContent || '').trim().toLowerCase();
        for (var j = 0; j < SIZE_WORDS.length; j++) {
          if (label.indexOf(SIZE_WORDS[j]) === 0) return headers[i];
        }
      }
      return null;
    }

    function place() {
      var info = document.querySelector('.product-info');
      if (!info) return true;

      var block = info.querySelector('.shopify-app-block');
      if (!block) return false;
      if (block.dataset.mfSizeChartMoved === 'true') return true;
      if (!block.textContent.trim() && !block.querySelector('a, button')) return false;

      var header = findSizeHeader(info);
      if (!header) return true;

      block.dataset.mfSizeChartMoved = 'true';
      block.classList.add('mf-size-chart-inline');
      header.classList.add('mf-has-size-chart');
      header.appendChild(block);
      return true;
    }

    function start() {
      if (place()) return;

      var timer = window.setInterval(function () {
        tries += 1;
        if (place() || tries > 60) window.clearInterval(timer);
      }, 250);

      var info = document.querySelector('.product-info');
      if (!info || !window.MutationObserver) return;

      var observer = new MutationObserver(function () {
        place();
      });
      observer.observe(info, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-staffel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-staffel]').forEach(function (root) {
      if (root.dataset.mfStaffelReady) return;
      root.dataset.mfStaffelReady = '1';

      var data = root.querySelector('[data-mf-staffel-variants]');
      if (!data) return;

      var variants = [];
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      var colorPos = parseInt(root.dataset.colorPos, 10) || 1;
      var kaarten = Array.prototype.slice.call(root.querySelectorAll('[data-mf-staffel-kaart]'));
      var button = root.querySelector('[data-mf-staffel-add]');
      var label = root.querySelector('[data-mf-staffel-label]');
      var error = root.querySelector('[data-mf-staffel-error]');

      function find(rij) {
        var colorEl = rij.querySelector('[data-mf-staffel-color]');
        var sizeEl = rij.querySelector('[data-mf-staffel-size]');
        var colorVal = colorEl ? colorEl.value : null;
        var sizeVal = sizeEl ? sizeEl.value : null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var first = colorPos === 1 ? v.o1 : v.o2;
          var second = colorPos === 1 ? v.o2 : v.o1;
          var colorOk = colorVal === null || first === colorVal;
          var sizeOk = sizeVal === null || second === sizeVal;
          if (colorOk && sizeOk) return v;
        }
        return null;
      }

      function open(kaart) {
        kaarten.forEach(function (k) {
          var aan = k === kaart;
          k.classList.toggle('is-open', aan);
          var rijen = k.querySelector('[data-mf-staffel-rijen]');
          if (rijen) rijen.hidden = !aan;
          var radio = k.querySelector('[data-mf-staffel-radio]');
          if (radio) radio.checked = aan;
        });
      }

      kaarten.forEach(function (kaart) {
        kaart.querySelector('.mf-staffel__kop').addEventListener('click', function () {
          open(kaart);
        });
      });

      var start = kaarten.filter(function (k) {
        var r = k.querySelector('[data-mf-staffel-radio]');
        return r && r.checked;
      })[0] || kaarten[0];
      if (start) open(start);

      var anchor = document.querySelector('.product-info [data-buy-buttons]');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(root, anchor);
        if (root.dataset.hideAtc === 'true') anchor.style.display = 'none';
      }

      button.addEventListener('click', function () {
        error.hidden = true;
        var kaart = kaarten.filter(function (k) { return k.classList.contains('is-open'); })[0];
        if (!kaart) return;

        var rijen = Array.prototype.slice.call(kaart.querySelectorAll('[data-mf-staffel-rij]'));
        var items = [];
        var missing = false;

        rijen.forEach(function (rij) {
          var v = find(rij);
          if (!v) { missing = true; return; }
          items.push({ id: v.id, quantity: 1 });
        });

        if (missing || items.length !== rijen.length) {
          error.textContent = 'That combination is not available. Please pick another colour or size.';
          error.hidden = false;
          return;
        }

        var original = label.textContent;
        button.disabled = true;
        label.textContent = 'Adding';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () {
            button.disabled = false;
            label.textContent = original;
            error.textContent = 'Something went wrong adding these to your cart. Please try again.';
            error.hidden = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
